"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sleep;
/** returns a promise that sleeps for specified time in ms. default 0 */
function sleep(ms = 0) {
  return new Promise(resolve => setTimeout(() => resolve(null), ms));
}